import {mapGetters} from 'vuex'

const pluginAccount = {
    ...mapGetters(['getCompteGL']),
    install(Vue) {
        Vue.prototype.$accountIndexFromNumber =  function(accountNumber) {
            let i;

            for(i=0; i < this.getCompteGL.length; i++) //lire tous les comptes
            {
                if(this.getCompteGL[i].number == accountNumber) //vérifier si le numéro de compte correspond
                {
                    return i //retourner l'index
                }
            }

            return null
        }
    }
}
    
export default pluginAccount